import { AppBar, Box, Toolbar, Typography } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import {MONITOR_COLORS, formatTime, getServerTime} from "../config/functions";
import Logotipo from "../../../../../assets/images/stw_logo.svg";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import 'dayjs/locale/pt-br';
import axios from "axios";
import {urlServerTime} from "../../../../../constants/endpoints";
import {useNavigate} from "react-router-dom";

export function MonitorHeader() {
    const navigate = useNavigate();

    const [serverTime, setServerTime] = useState(null);

    useEffect(() => {
        const fetchTime = async () => {
            const res = await getServerTime();
            const [h, m, s] = res.data.time.split(':').map(Number);
            const totalSeconds = h * 3600 + m * 60 + s;
            setServerTime({ totalSeconds });
        };

        fetchTime();
    }, []);

    useEffect(() => {
        if (!serverTime) return;

        const interval = setInterval(() => {
            setServerTime(prev => ({ totalSeconds: prev.totalSeconds + 1 }));
        }, 1000);

        return () => clearInterval(interval);
    }, [serverTime !== null]);

    return (
        <AppBar position="fixed" sx={{
            height: '10vh',
            backgroundColor: MONITOR_COLORS.secondary,
            borderBottom: '4px solid ' + MONITOR_COLORS.tertiary,
        }}>
            <Toolbar sx={{
                height: '100%',
                width: '100%',
                maxWidth: 1920,
                mx: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: { xs: 2, md: 3 },
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box
                        component="img"
                        src={Logotipo}
                        sx={{
                            height: 40,
                            width: 'auto',
                            '&:hover': {
                                cursor: 'pointer',
                            },
                        }}
                        onClick={() => navigate('/')}
                    />

                    <Box sx={{ width: '1px', height: 36, bgcolor: MONITOR_COLORS.tertiary }} />

                    <Box>
                        <Typography sx={{
                            fontSize: { xs: '1rem', md: '1.3rem', lg: '1.5rem' },
                            fontWeight: 700,
                            color: MONITOR_COLORS.text.primary,
                            lineHeight: 1.2,
                        }}>
                            Dashboard de Monitoramento
                        </Typography>

                        <Typography sx={{
                            fontSize: '0.72rem',
                            color: MONITOR_COLORS.text.secondary,
                            letterSpacing: '0.05em',
                        }}>
                            Safe To Work • Gestão de EPI's
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{ textAlign: 'center' }}>
                        <Typography sx={{
                            fontSize: { xs: '1.2rem', md: '1.5rem' },
                            fontWeight: 700,
                            color: MONITOR_COLORS.text.primary,
                            lineHeight: 1.2,
                            fontFamily: 'monospace',
                        }}>
                            {serverTime ? formatTime(serverTime.totalSeconds) : '--:--:--'}
                        </Typography>

                        <Typography sx={{
                            fontSize: '0.72rem',
                            color: MONITOR_COLORS.text.secondary,
                        }}>
                            {dayjs().locale('pt-br').format('ddd, D [de] MMM[.]')}
                        </Typography>
                    </Box>

                    <Box sx={{ width: '1px', height: 36, bgcolor: MONITOR_COLORS.tertiary }} />
                </Box>
            </Toolbar>
        </AppBar>
    );
}